import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "clip-rule": "evenodd",
      d: "M3.667 5.99a2.322 2.322 0 0 1 2.322-2.323h32.022a2.322 2.322 0 0 1 2.323 2.322v32.022a2.322 2.322 0 0 1-2.323 2.323H5.99a2.322 2.322 0 0 1-2.322-2.323V5.99z",
      stroke: "currentColor",
      "stroke-width": "2.322"
    }, null, -1),
    _createElementVNode("path", {
      d: "M19.532 15.217h3.227v14.117h-2.683l-7.038-8.571v8.57H9.812V15.218h2.702l7.018 8.57v-8.57zM29.244 18.323c3.308 0 5.224 1.532 5.224 4.82v6.19h-2.945v-1.35c-.584.988-1.714 1.512-3.307 1.512-2.541 0-4.053-1.412-4.053-3.287 0-1.916 1.35-3.247 4.658-3.247h2.5c0-1.351-.806-2.138-2.5-2.138-1.15 0-2.34.383-3.126 1.008l-1.13-2.198c1.19-.847 2.945-1.31 4.68-1.31zm-.241 9.054c1.048 0 1.956-.484 2.319-1.472v-1.109h-2.158c-1.472 0-1.936.544-1.936 1.27 0 .787.665 1.311 1.774 1.311z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }